import { importWhenVisible } from '@studiometa/js-toolkit';
import { Panel, Modal } from '@studiometa/ui';

/**
 * Cart component
 * @see https://liquid-ajax-cart.js.org/v2/
 */
export default class Cart extends Panel {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Cart',
    refs: ['checkout', 'finalPrice', ...Modal.config.refs],
    components: {
      CrossSell: (app) =>
        importWhenVisible(() => import('../../Sections/Slider/index.js'), 'CrossSell', app),
    },
  };

  /**
   * mounted
   */
  mounted() {
    super.mounted();
    document.addEventListener('liquid-ajax-cart:request-end', (event) => {
      const { requestState } = event.detail;

      // If the "add to cart" request is successful
      if (requestState.requestType === 'add' && requestState.responseData?.ok) {
        super.open();
      }

      if (!requestState.responseData?.ok) {
        this.$root.Toaster.addToast(requestState.responseData?.body?.message);
      }

      const badge = document.querySelector('[data-cart-count-badge]');
      if (badge) {
        const count = event.detail.cart?.item_count ?? 0;
        badge.classList.toggle('opacity-0', count === 0);
        badge.classList.toggle('scale-0', count === 0);
      }

      this.$root.$update();
    });
  }
}
